function debounce(func, wait) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
}

function throttle(func, limit) {
	let inThrottle;
	let lastFunc;
	let lastRan;
	return function () {
		const context = this;
		const args = arguments;
		if (!inThrottle) {
			func.apply(context, args);
			lastRan = Date.now();
			inThrottle = true;
			setTimeout(function () {
				inThrottle = false;
			}, limit);
		} else {
			clearTimeout(lastFunc);
			lastFunc = setTimeout(
				function () {
					if (Date.now() - lastRan >= limit) {
						func.apply(context, args);
						lastRan = Date.now();
					}
				},
				limit - (Date.now() - lastRan),
			);
		}
	};
}

function initSafeSticky() {
	const RESIZE_DEBOUNCE = 150;

	const stickies = Array.from(document.querySelectorAll(".sticky-details-container"));
	if (!stickies.length) return;

	stickies.forEach((el) => {
		let initialTop = 0;
		let lastY = window.scrollY || 0;
		let currentTop = 0;
		let position = "relative";
		let centerMode = el.hasAttribute("safe-sticky-center");

		const check = throttle(checkPosition, 16);
		const resizeObserver = new ResizeObserver(debounce(() => recalc(), RESIZE_DEBOUNCE));
		const mutationObserver = new MutationObserver(() => recalc());

		function recalc() {
			el.style.removeProperty("top");
			const computed = getComputedStyle(el);
			initialTop = parseInt(computed.top) || 0;
			position = computed.position;
			centerMode = el.hasAttribute("safe-sticky-center");
			currentTop = initialTop;
			lastY = window.scrollY || 0;
			check();
		}

		function checkPosition() {
			if (position !== "sticky") {
				el.style.removeProperty("top");
				return;
			}

			const h = el.getBoundingClientRect().height;
			const vh = window.innerHeight;

			if (centerMode && h <= vh) {
				const centeredTop = Math.max(initialTop, Math.round((vh - h) / 2));
				el.style.top = `${centeredTop}px`;
				lastY = window.scrollY || 0;
				return;
			}

			const bounds = el.getBoundingClientRect();
			const maxTop = bounds.top + window.scrollY - el.offsetTop + initialTop;
			const minTop = el.clientHeight - window.innerHeight;

			const y = window.scrollY || 0;
			if (y < lastY) currentTop -= y - lastY;
			else currentTop += lastY - y;

			currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTop);
			lastY = y;

			el.style.top = `${Math.round(currentTop)}px`;
		}

		mutationObserver.observe(el, { childList: true, subtree: true });
		resizeObserver.observe(el);
		window.addEventListener("scroll", check, { passive: true });
		window.addEventListener("resize", check, { passive: true });

		recalc();
	});
}

document.addEventListener("DOMContentLoaded", () => {
    initSafeSticky();
});